// DS: i7.2
import React from 'react';
import IconWrap from '../../IconWrap';
const FloatRight = (props)=>{
    return /*#__PURE__*/ React.createElement(IconWrap, props, /*#__PURE__*/ React.createElement("svg", {
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M21 19a1 1 0 01.117 1.993L21 21H3a1 1 0 01-.117-1.993L3 19h18zm0-12a1 1 0 01.993.883L22 8v8a1 1 0 01-.883.993L21 17h-9a1 1 0 01-.993-.883L11 16V8a1 1 0 01.883-.993L12 7h9zM8 15a1 1 0 01.117 1.993L8 17H3a1 1 0 01-.117-1.993L3 15h5zm0-4a1 1 0 01.117 1.993L8 13H3a1 1 0 01-.117-1.993L3 11h5zm0-4a1 1 0 01.117 1.993L8 9H3a1 1 0 01-.117-1.993L3 7h5zm13-4a1 1 0 01.117 1.993L21 5H3a1 1 0 01-.117-1.993L3 3h18z"
    })));
};
FloatRight.displayName = 'FloatRight';
export default FloatRight;
